/**
 * Centralized localStorage keys + typed accessors used by the EditTicket view.
 */
export const EDIT_TICKET_STORAGE_KEYS = {
  sideViewFilterIndex: 'widget_ticket_view_id',
  activeMenuKey: 'ticket_detail_active_menu_index',
  customFormLocation: 'TikitCustomFormLocation'
} as const;

export const getSideViewFilterIndex = (): number => {
  const raw = localStorage.getItem(EDIT_TICKET_STORAGE_KEYS.sideViewFilterIndex);
  const parsed = parseInt(raw || '0');
  return Number.isFinite(parsed) ? parsed : 0;
};

export const setSideViewFilterIndex = (index: number): void => {
  localStorage.setItem(EDIT_TICKET_STORAGE_KEYS.sideViewFilterIndex, index.toString());
};

export const getActiveMenuKey = (): string =>
  localStorage.getItem(EDIT_TICKET_STORAGE_KEYS.activeMenuKey) || 'activity';

export const setActiveMenuKey = (key: string): void => {
  localStorage.setItem(EDIT_TICKET_STORAGE_KEYS.activeMenuKey, key);
};

export const isCustomFormTabLocation = (): boolean =>
  (localStorage.getItem(EDIT_TICKET_STORAGE_KEYS.customFormLocation) || 'tab') === 'tab';
